import { GetterTree } from 'vuex'
import { StatisticState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<StatisticState, RootState> = {
    callStatisticDetail: state => state.callStatisticDetail,
    callStatisticDetailFlag: state => state.callStatisticDetailFlag,
    callStatisticDetailIncoming: state => state.callStatisticDetailIncoming,

    callStatisticGroup: state => state.callStatisticGroup,
    callStatisticGroupIncoming: state => state.callStatisticGroupIncoming,
    callGroupBy: state => state.callGroupings.callGroup,
    callGroupByOptionally: state => state.callGroupings.callGroupByOptionally,
    callGroupByIncoming: state => state.callGroupings.callGroupByIncoming,
    callGroupByOptionallyIncoming: state => state.callGroupings.callGroupByOptionallyIncoming,
};
